import React, { useState } from "react";

const MultipleChoice = ({ options, index, answer, disabled = true, other }) => {
  const [val, setValue] = useState([]);

  let otherOption = { ...other, answer: "Other" };
  let renderOptions = other ? [...options, otherOption] : options;

  const handleChange = (e) => {
    e.target.checked ? setValue(prev => [...prev, e.target.value]) : setValue(prev => prev.filter(it => it !== e.target.value));
  }

  return (
    <div className="uk-form-controls uk-margin-small-top">
      {renderOptions
        ?.filter((option) => !option.deleted)
        .map((option, i) => (
          <div key={i}>
            <label className="hms-choice">
              <input
                className="uk-radio"
                type="checkbox"
                value={option.answer}
                onChange={handleChange}
                id={`survey${index}-${i}`}
                disabled={disabled}
                defaultChecked={option.answer == answer}
              />
              <span className="hms-checkmark"></span>
              {option.answer}
            </label>
          </div>
        ))}
        {
          val.includes("Other") && <div className="uk-form-controls uk-margin-small-top">
            <textarea
              className="uk-textarea uk-width-2-3"
              rows="3"
            >
              {answer}
            </textarea>
          </div>
        }
    </div>
  );
};

export default MultipleChoice;
